import { useState, useEffect } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomSelect from "../globalno-dodavanje/CustomSelect";
import CustomCalendarInput from "./CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";

const nowDate = new Date()
  .toLocaleDateString("sr-RS", { day: "2-digit", month: "2-digit", year: "numeric" })
  .replaceAll("/", ".")
  .slice(0, -1);

const emptyObrazac = {
  radnoMesto: { id: -1, name: "" },
  zaposlen: { id: -1, name: "" },
  datum: nowDate,
};

function EvidencijeObrazac3Dodavanje({ setIsDodavanje, onRefresh }) {
  const [obrazac, setObrazac] = useState(emptyObrazac);
  const [radnaMesta, setRadnaMesta] = useState([]);
  const [zaposleni, setZaposleni] = useState([]);

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/evidencija1/get_lookups.php`,
          { company_id: selectedMainEntity.company_id }
        );
        if (data.status === 200) {
          setRadnaMesta(data.radna_mesta);
          setZaposleni(data.zaposleni);
        }
      } catch (e) {
        console.error("Greška:", e);
      }
    };
    fetchLookups();
  }, []);

  const handleChange = (newValue, field) => {
    setObrazac((prev) => ({ ...prev, [field]: newValue }));
  };

  const formatDateForApi = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split(".");
    if (parts.length < 3) return null;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/evidencija3/create.php`,
        {
          company_id: selectedMainEntity.company_id,
          workplace_id: obrazac.radnoMesto.workplace_id || obrazac.radnoMesto.id,
          employee_id: obrazac.zaposlen.employee_id || obrazac.zaposlen.id,
          datum_bolesti: formatDateForApi(obrazac.datum),
        }
      );
      if (data.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const handleOdustani = () => setIsDodavanje(false);

  const isDisabledSacuvaj = obrazac.zaposlen.id === -1 || obrazac.radnoMesto.id === -1;

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div style={{ display: "flex", gap: "10px" }}>
        <div style={{ width: "15vw" }}>
          <CustomSelect
            label="РАДНО МЕСТО"
            allValues={radnaMesta}
            selectedValue={obrazac.radnoMesto}
            onSelectChange={(newValue) => handleChange(newValue, "radnoMesto")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <CustomSelect
            label="ИМЕ И ПРЕЗИМЕ"
            allValues={zaposleni}
            selectedValue={obrazac.zaposlen}
            onSelectChange={(newValue) => handleChange(newValue, "zaposlen")}
          />
        </div>

        <CustomCalendarInput
          label="ДАТУМ"
          value={obrazac.datum}
          onChange={(v) => handleChange(v, "datum")}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "25px" }}>
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>ОДУСТАНИ</Button>
        </div>
        <div onClick={isDisabledSacuvaj ? undefined : handleSacuvaj} style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}>
          <Button isDisabled={isDisabledSacuvaj} activation={true} style={styles.button}>САЧУВАЈ</Button>
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac3Dodavanje;